import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { IConfirmationDialogOptions } from './confirmation-dialog/confirmation-dialog-options.interface';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { IInformationDialogOptions } from './information-dialog/information-dialog-options.interface';
import { InformationDialogComponent } from './information-dialog/information-dialog.component';
import { ICustomDialogOptions } from './custom-dialog/custom-dialog-options.interface';
import { CustomDialogComponent } from './custom-dialog/custom-dialog.component';
import { DeleteTasksDialogComponent } from '../../../admin/calendar-page/calendar-old/delete-tasks-dialog/delete-tasks-dialog.component';
import { IDeleteTasksDialogOptions } from '../../../admin/calendar-page/calendar-old/delete-tasks-dialog/delete-tasks-dialog-options.interface';
// import { IDeleteTasksDialogOptions } from 'app/calendar/delete-tasks-dialog/delete-tasks-dialog-options.interface';
// import { DeleteTasksDialogComponent } from 'app/calendar/delete-tasks-dialog/delete-tasks-dialog.component';

let self: any;

@Injectable()
export class DialogService {
  confirmationDialogRef!: MatDialogRef<any>;
  informationDialogRef!: MatDialogRef<any>;

  constructor(private _dialog: MatDialog) {
    self = this;
  }

  openConfirmationModal(modalOptions: IConfirmationDialogOptions, viewContainerRef: any) {
    let config = new MatDialogConfig();

    // config.disableClose = true;
    config.maxWidth = '90vw';
    config.viewContainerRef = viewContainerRef;
    self.confirmationDialogRef = this._dialog.open(ConfirmationDialogComponent, config);
    self.confirmationDialogRef.componentInstance.modalOptions = modalOptions || {};

    return self.confirmationDialogRef.afterClosed();
  }

  openInformationModal(modalOptions: IInformationDialogOptions, viewContainerRef: any) {
    let config = new MatDialogConfig();

    config.disableClose= true;
    config.maxWidth = '90vw';
    config.viewContainerRef = viewContainerRef;
    self.informationDialogRef = this._dialog.open(InformationDialogComponent, config);
    self.informationDialogRef.componentInstance.modalOptions = modalOptions || {};

    return self.informationDialogRef.afterClosed();
  }

  openCustomModal(modalOptions: ICustomDialogOptions, viewContainerRef: any) {
    let config = new MatDialogConfig();

    config.disableClose= true;
    config.maxWidth = '90vw';
    config.viewContainerRef = viewContainerRef;
    self.customDialogRef = this._dialog.open(CustomDialogComponent, config);
    self.customDialogRef.componentInstance.modalOptions = modalOptions || {};

    return self.customDialogRef.afterClosed();
  }

  openDeleteTasksModal(modalOptions: IDeleteTasksDialogOptions, viewContainerRef: any) {
    let config = new MatDialogConfig();

    config.disableClose= true;
    config.maxWidth = '90vw';
    config.viewContainerRef = viewContainerRef;
    self.deleteDialogRef = this._dialog.open(DeleteTasksDialogComponent, config);
    self.deleteDialogRef.componentInstance.modalOptions = modalOptions || {};

    return self.deleteDialogRef.afterClosed();
  }
}
